import { render, staticRenderFns } from "./SPDistritos.vue?vue&type=template&id=f45470f0&scoped=true&"
import script from "./SPDistritos.vue?vue&type=script&lang=js&"
export * from "./SPDistritos.vue?vue&type=script&lang=js&"
import style0 from "./SPDistritos.vue?vue&type=style&index=0&id=f45470f0&lang=scss&scoped=true&"
import style1 from "./SPDistritos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45470f0",
  null
  
)

export default component.exports